//shared between videoproduct and videogallery
const videoCommon = function(){
	const videoTranscripts = new videoTranscripts4i();

	const addLinks = () =>{
		const playArea = [].slice.call(document.querySelectorAll(".vjs-poster"));
		for(let n = 0; n < playArea.length; n++){
			addVideoClass(playArea[n].getElementsByTagName("img")[0]);
			playArea[n].addEventListener("click", removeVideoClass);
		}
		const playBtn = [].slice.call(document.querySelectorAll(".vjs-big-play-button"));
		for(let x = 0; x < playBtn.length; x++){
			addVideoClass(playBtn[x]);
			playBtn[x].addEventListener("click", removeVideoClass);
		}
	};
	
	const addVideoClass = (el) =>{
		el.classList.add("videoLink"); // for GTM, don't remove
		
		const productName = document.querySelector(".prodName") ? document.querySelector(".prodName").innerHTML : "";
		if(productName !== ""){ // is product gallery page
			const svg = document.createElement("svg");
			el.appendChild(svg);
			el.querySelector("svg").setAttribute("aria-label", "Video Gallery for " + productName);
		}
	};
	
	const removeVideoClass = (e) =>{
		e.preventDefault();
		const playArea = [].slice.call(document.querySelectorAll(".vjs-poster"));
		for(let i = 0; i < playArea.length; i++){
			playArea[i].getElementsByTagName("img")[0].classList.remove("videoLink");
		}
		const playBtn = [].slice.call(document.querySelectorAll(".vjs-big-play-button"));
		for(let x = 0; x < playBtn.length; x++){
			playBtn[x].classList.remove("videoLink"); 
		}	
	};
	
	const showFromDialog = () =>{
		if (window.location.hash == "#mugimprints"){
			setTimeout(() => { 
				const mugImprintBtn = document.getElementById("mugImprintVideo");
				mugImprintBtn.click();
				setTranscriptFocus();
			}, 300);
		}else if(window.location.hash == "#transcript"){
			setTimeout(() => { setTranscriptFocus(); }, 300);
		}
	};
	
	const setTranscriptFocus = () =>{
		videoTranscripts.Collapse();
		const transcriptDiv = document.getElementById("transcriptContainer");
		transcriptDiv.focus();
	};
	
	return{
		AddLinks: addLinks, 
		ShowFromDialog: showFromDialog
	};
};